// src/components/dashboard/NotificationsSection.tsx
import React, { useEffect, useState, useCallback } from 'react'
import { apiService } from '../../services/api'
import { Loader2, Bell } from 'lucide-react'

interface NotifItem {
  id: string
  title: string
  message: string
  priority: string
  frequency: string
  createdAt: string
  isRead: boolean
}

const PRIORITY: Record<string, { bg: string; border: string; dot: string }> = {
  info: { bg: 'bg-blue-50', border: 'border-blue-200', dot: 'bg-blue-500' },
  warning: { bg: 'bg-orange-50', border: 'border-orange-200', dot: 'bg-orange-500' },
  important: { bg: 'bg-red-50', border: 'border-red-200', dot: 'bg-red-500' },
}

export default function NotificationsSection() {
  const [items, setItems] = useState<NotifItem[]>([])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = await apiService.getNotifications()
      setItems(res.items || [])
      apiService.markNotificationsRead().catch(() => {}) // sayfaya girince hepsi okundu
    } catch { /* sessiz */ }
    finally { setLoading(false) }
  }, [])

  useEffect(() => { load() }, [load])

  const fmt = (d: string) =>
    new Date(d).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-gray-800">Sistem Mesajları</h1>
        <p className="text-sm text-gray-500">Tüm bildirimleriniz</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-orange-500" /></div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <Bell className="w-10 h-10 mx-auto mb-3 text-gray-300" />
          Henüz mesaj yok.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(n => {
            const p = PRIORITY[n.priority] || PRIORITY.info
            return (
              <div key={n.id} className={`rounded-xl border ${p.border} ${p.bg} p-4`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className={`w-2 h-2 rounded-full ${p.dot} shrink-0`} />
                  <span className="font-semibold text-gray-800">{n.title}</span>
                  <span className="text-xs text-gray-400 ml-auto shrink-0">{fmt(n.createdAt)}</span>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap break-words">{n.message}</p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
